module.exports = "/images/vendor/flag-icon-css/flags/1x1/kg.svg?5908392a2d107a3f7db5cc793b8716ab";